<h6>Splits Details - {{name}}
</h6>
<div align="center" *ngIf="Error">
    {{Error}}
</div>
<mat-dialog-content class="mat-typography" style="padding: 10px">
    <table *ngIf="splits && splits.length > 0" mat-table [dataSource]="splits" class="mat-elevation-z8">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{ getColumName(column) }} </th>
        <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
      </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <small *ngIf="isDifferentLocationItemSelected" style="color: red;" >You cannot select "Farm & Field" because you have chosen items from different locations.</small>
    <button mat-button class="ta-splits-select text-white magin_5 btn btn-success" [disabled]="isDifferentLocationItemSelected || !splits || splits.length == 0"  [mat-dialog-close]="true">Select</button>
    <button mat-button class="ta-splits-close mat-stroked-button-WhiteBackground-GreenText ta-customer-openbooking magin_5 color_green" [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>
